import axios from "axios";
import { toast } from "react-toastify";
import { GET_ABHIBUS_HISTORY } from "../../Store/Type";

const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});
const apiUrl = process.env.REACT_APP_API_URL;
export const GetAbhiBusHistory = async (dispatch, setSpinning) => {
  try {
    const response = await api.get(
      `${apiUrl}/getall/abiBusHistory`
    );
    // console.log(response?.data?.data, "all blocked details")
    dispatch({ type: GET_ABHIBUS_HISTORY, payload: response?.data });
    return response?.data;
  } catch (err) {
    console.log("Error fetching blocked details:", err);
  } finally {
    setSpinning && setSpinning(false);
  }
};
